module.exports = __webpack_public_path__ + "img/error-icon.bf427567.png";